function Profile() {
	return (<>
		<section>
			<header className="major">
				<h2>A little more about me.</h2>
			</header>
			<p>
				My name is Mehtab Iqbal but everyone calls me <span className='textbf'>Shahan</span>, and I prefer that.
				I am a <span className='textbf'>Human-Centered Computing Ph.D.</span> student at Clemson University, under the supervision
				of <a href="https://www.usabart.nl/portfolio/#home.html" target="_blank" rel="noreferrer">Dr. Bart Knijnenburg</a>.
			</p>
			<p className="textit textbf">
				I develop and evaluate tools that democratize computation by being easily comprehensible, more accessible,
				and ultimately inclusive. 
				{/* for that, I start in the classroom and with introductory programming.
				My research utilizes programming language theory, learning sciences, and AI to build inclusive and accessible development tools. */}
			</p>
			<p>
				I work at the <a href="http://hatlab.org/" target="_blank" rel="noreferrer">HATLab</a> at Clemson University, School of Computing,
				where I am currently the webmaster, so if you come across any inconsistencies, or errors please let me know.
			</p>
			{/* <p>
				I also work with Dr. Nina Hubig, at the <a href="https://sites.google.com/view/dzrpt-lab/home" target="_blank" rel="noreferrer">Dzrpt Lab</a>,
				where I research AI explainability, interpreting neural networks and large-scale models, and digital agents.
			</p> */}
			<p>
				On weekends, I am usually out hiking or kayaking on the nearby trails and lakes. I like to cook and explore new recipes. I do not get
				to play video games nearly as much as I would like but I do that too.
				Other than that, I try to garden and I like to grow chillies.
			</p>
		</section>
	</>)
}

export default Profile;
